export const selectStoreToken = (store)=>store.authSlice.token
